require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-alphington-paper-mill-transformed-into-warehouse-style.json") })
        }
      }, "path---news-alphington-paper-mill-transformed-into-warehouse-style");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-alphington-paper-mill-transformed-into-warehouse-style!./.cache/json/news-alphington-paper-mill-transformed-into-warehouse-style.json
// module id = 785
// module chunks = 231608221292675